import ListSPKRAP from './ListSPKRAP';

export default ListSPKRAP;
